import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70" role="navigation" aria-label="主导航">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="韩漫首页">
              <span className="font-heading text-2xl font-bold text-primary-600 tracking-tight">韩漫</span>
              <span className="hidden sm:inline font-sans text-sm text-foreground-500 font-light">comic.kr</span>
            </Link>
            <div className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rexue" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">分类</Link>
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">排行榜</Link>
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">最新更新</Link>
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              {searchOpen && (
                <div className="absolute right-0 top-1/2 -translate-y-1/2 flex items-center bg-background-100 rounded-full px-3 py-2 animate-in">
                  <input
                    type="text"
                    placeholder="搜索漫画..."
                    className="bg-transparent text-sm text-foreground-900 outline-none w-40 placeholder:text-foreground-400"
                    aria-label="搜索漫画"
                  />
                  <i className="ri-search-line text-foreground-500 text-sm"></i>
                </div>
              )}
              {!searchOpen && (
                <button
                  onClick={() => setSearchOpen(true)}
                  className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
                  aria-label="打开搜索"
                >
                  <i className="ri-search-line text-lg text-foreground-600"></i>
                </button>
              )}
            </div>

            <Link
              to="/"
              className="hidden sm:flex bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line ml-1.5"></i>
            </Link>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="切换菜单"
            >
              <i className={`text-lg text-foreground-600 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70 pt-3 flex flex-col gap-2">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>首页</Link>
            <Link to="/category/rexue" className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>分类</Link>
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>排行榜</Link>
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>最新更新</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-600 py-2 px-2 rounded-lg hover:bg-background-100 transition-colors" onClick={() => setMobileOpen(false)}>关于我们</Link>
          </div>
        )}
      </div>
    </nav>
  );
}